import React, { useState, useEffect } from 'react';
import { protectedAPI } from '../services/api';
import Stats from './Stats.js';
import JournalTable from './JournalTable.js'
import Header from './Header.js'
import Addresses from './Addresses.js';
import CamerasGrid from './CamerasGrid.js'
import ItemList, { CameraStatus } from './ItemList.jsx';
import { AuthProvider, useAuth } from '../context/AuthContext';
import HlsLlPlayer from './HlsLlPlayer.js';

const Dashboard = () => {
  const [systemState, setSystemState] = useState([]);
  const [lastRecognitions, setLastRecognitions] = useState([]);
  const [cameras, setCameras] = useState([]);
  const [barriers, setBarriers] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [cors, setCors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const { user, logout } = useAuth();

  useEffect(() => {
    fetchSystemState();
    fetchLastRecognitions();
    fetchCameras();
    fetchAddresses();
    fetchBarriers();
  }, []);

  const fetchSystemState = async () => {
    try {
      const response = await protectedAPI.getSystemState();
      setSystemState(response.data);
    } catch (error) {
      setError('Failed to fetch system state');
    } finally {
      setLoading(false);
    }
  };

  const fetchLastRecognitions = async () => {
    try {
      const response = await protectedAPI.getRecognitionHistoryLast();
      setLastRecognitions(response.data);
    } catch (error) {
      setError('Failed to fetch last recognitions');
    } finally {
      setLoading(false);
    }
  };

  const fetchAddresses = async () => {
    try {
      const response = await protectedAPI.getAddresses();
      setAddresses(response.data);
    } catch (error) {
      setError('Failed to fetch address');
    } finally {
      setLoading(false);
    }
  };

  const fetchBarriers = async () => {
    try {
      const response = await protectedAPI.getBarriers();
      setBarriers(response.data);
    } catch (error) {
      setError('Failed to fetch barrier');
    } finally {
      setLoading(false);
    }
  };

  const fetchCameras = async () => {
    try {
      const response = await protectedAPI.getCameras();
      setCameras(response.data);
    } catch (error) {
      setError('Failed to fetch camera');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Загрузка...</div>;

  return (
    <div className="protected-data">
      {/*Заголовок страницы*/}
      <Header title='Панель управления' userId={user.id} systemState={systemState}></Header>

      {/*Поле вывода ошибок (дебаг)*/}
      {error && <div className="error">{error}</div>}

      {/*Данные о системе}
      <Stats systemState={systemState}></Stats>
      {*/}

      <CamerasGrid cameras={cameras}></CamerasGrid>

      <ItemList></ItemList>

      {/*Последние события*/}
      {/*}
      <JournalTable journalList={lastRecognitions} ></JournalTable>
      {*/}

      {/*Список адресов со шлагбаумами и камерами}
      <Addresses addresses={addresses} barriers={barriers} cameras={cameras}></Addresses>
      {*/}
    </div>
  );
};

export default Dashboard;
